export default __webpack_public_path__ + "assets/partly-cloudy-night-fog.b8e4f85f.svg";